import React from "react";
import { QuestionStep, QuestionStepProps } from "./QuestionStep";

import { OnboardingProps } from "components/Onboarding/models";

export interface AngiAutoResponderQuestionStepProps
    extends Omit<
        QuestionStepProps<OnboardingProps>,
        "title" | "hasValueLabel" | "noValueLabel" | "valueLabel" | "renderInput" | "canClickNext" | "initialValue"
    > {}

export const AngiAutoresponderQuestionStep = (props: AngiAutoResponderQuestionStepProps) => {
    return (
        <QuestionStep<OnboardingProps>
            title="Do you use Angi Auto Responders?"
            description="Angi Auto Responders help you close business faster by automatically responding to leads.  You can include a Book Now link in your response to help convert leads into customers."
            hasValueLabel="Yes, I use Auto Responders"
            hasValueDescription="Great!  We will provide you with a booking link you can use in your Auto Responder email."
            noValueLabel="No, I don't use Auto Responders yet"
            noValueDescription="No problem!  They are easy to setup and we can help you get started."
            valueLabel=""
            canClickNext={(hasValue) => typeof hasValue === "boolean"} // Can proceed if they've selected yes/no
            {...props}
        />
    );
};
